export default "__VITE_ASSET__BYbGzop___"